import axios from "axios";
import { BASE_URL } from "@/service_urls";



const subscription = {
    getSubscriptions: (queryString='') => axios.get(`${BASE_URL}/subscriptions/?${queryString}`),
    getSubscriptionOptions: (queryString='') => axios.get(`${BASE_URL}/subscription_options/?${queryString}`),
    updatePartnerSubscription: (payload) => axios.put(`${BASE_URL}/customer_organisation_subscriptions/update-subscription`, payload),
    getPartnerSubscriptionTypes: () => axios.get(`${BASE_URL}/subscription_types/partner-subscriptions`),
    getSubscriptionByCusOrg:(customer_organisation_id) => axios.get(`${BASE_URL}/customer_organisation_subscriptions/customer-organisation/${customer_organisation_id}`),
};

export default subscription;
